<template>

  <div class="personWeaponTableContainer">
    <h5 tabindex="0" class="weaponContainerHeader">Person Weapons</h5>

    <div class="newBtnContainer">
      
      <TooltipHelper position="top" tooltip-text="Click here to Add a New Weapon to this Person.">
        <div class="newBtnContainer">
          <div tabindex="0" class="material-icons forIconEdit text-success addWeaponIcon" @keydown.enter="OpenAddNewPersonWeaponModal" @click="OpenAddNewPersonWeaponModal"> add_box </div>
        <a tabindex="0" herf="#" class="text-primary bolder" @keydown.enter="OpenAddNewPersonWeaponModal" @click="OpenAddNewPersonWeaponModal">
           Add a New Weapon
        </a>
        </div>
        
      </TooltipHelper>
    </div>

    <ModalBootstrap ModalId="createNewPersonWeaponModal" ModalTitle="Create a New Weapon for this Person" ButtonText="" ref="createNewPersonWeaponModal" aria-label="Create Record">

      <template v-slot:body>
        <PersonWeaponForm mode="new" v-if="newPersonWeaponObject" :person-weapon-object="newPersonWeaponObject" @person-weapon-submitted="CreateEditFormSubmitted" ref="personWeaponNewForm"></PersonWeaponForm>
      </template>

      <template v-slot:footer>

        <button type="button" class="btn btn-secondary" @click="this.$refs.createNewPersonWeaponModal.HideModal();">Cancel</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="this.$refs.personWeaponNewForm.Submit()">Submit</button>

      </template>
    </ModalBootstrap>

    <ModalBootstrap ModalId="updateQualModal" ModalTitle="Update Qual Date For this Weapon" ButtonText="" ref="updateQualModal" aria-label="Update Record" >

      <template v-slot:body>

        <PersonWeaponForm mode="edit" v-if="weaponEditing" :person-weapon-object="weaponEditing" @person-weapon-submitted="CreateEditFormSubmitted" ref="personWeaponEditForm"></PersonWeaponForm>
      </template>

      <template v-slot:footer>

        <button type="button" class="btn btn-secondary" @click="this.$refs.updateQualModal.HideModal();">Cancel</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="UpdateQual(weaponEditing)">Submit</button>

      </template>
    </ModalBootstrap>
   

    <div class="tableContainer">
      <DataTableComponent 
      v-if="this.getAllPersonWeaponUrl" 
      ref="personWeaponDatatable"
      :data-url="this.getAllPersonWeaponUrl" 
      :column-list-d-b="this.personWeaponColumnNames" 
      :column-list-pretty="this.personWeaponColumnNamesPretty" 
      column-name-id="personWeaponId" 
      :show-search="false" 
      :show-length-change="false"
      :rows-per-page="10"
      :show-paging="false"
      >
        <template #actionColumnEditSlot="actionColumnEditSlot">

          <td class="actionColumn tdclass">

            <TooltipHelper tabindex="0" position="left" tooltip-text="Click here to Update the Qual Expire Date for this Weapon.">
              <a herf="#" class="text-primary" @click="OpenUpdateQualModal(actionColumnEditSlot)">
                Update Qual
              </a>
            </TooltipHelper>

            <TooltipHelper position="left" tooltip-text="Click here to Delete this Weapon.">
              <a herf="#" class="text-danger" @click="DeleteWeapon(actionColumnEditSlot)">
                Delete
              </a>
            </TooltipHelper>

          </td>
         
          

        </template>
      </DataTableComponent>
    </div>
    
  </div>
  

</template> 
  
<script> 

  import DataTableComponent from "@/components/dataSupport/DataTable.vue";
  import { store } from "@/store/store.js";
  import TooltipHelper from "@/components/dataSupport/TooltipHelper.vue";
  import ModalBootstrap from "@/components/dataSupport/ModalBootstrap.vue";
  import PersonWeaponForm from "@/components/ProcessMasterListViews/PersonWeaponForm.vue";
  import $ from "jquery";

  export default {
    name: "PersonWeaponTable",
    components: {
      DataTableComponent,
      TooltipHelper,
      ModalBootstrap,
      PersonWeaponForm
    }, 
    props: {
      personId:Number,
    },
    data(){
      return{
        store,
        isMounted : false,
        getAllPersonWeaponUrl:null,
        personWeaponColumnNames:
        ['weaponName', 'qualExpirePretty', 'otherWeapon', 'serialNumber', 'weaponSource'],
        personWeaponColumnNamesPretty:
        ['Weapon', 'Qual Expire', 'Other', 'Serial Number', 'Source'],
        newPersonWeaponObject:null,
        weaponEditing:null,
        qualExpireInput:null,
      }
    },
    created(){ // called BEFORE rendering (load data here)
      this.getAllPersonWeaponUrl = this.store.webAPIUrl + "PersonWeapons/personWeaponListDTO/" + this.personId; 
    },
    mounted() { // called afer rendering
      this.isMounted = true; 
    },

    methods:{
      OpenAddNewPersonWeaponModal(){
        this.newPersonWeaponObject = {
          personId : this.personId, 
          serialNumber: '',
          weaponSource:'',
          weaponNameId:-1,
        }
        this.$refs.createNewPersonWeaponModal.ShowModal();
      },
      OpenUpdateQualModal(personWeaponObject){
        this.weaponEditing = personWeaponObject; 
        console.log("opening modal", personWeaponObject); 
        this.$refs.updateQualModal.ShowModal();
      },
      UpdateQual(personWeaponObj){
        console.log(personWeaponObj); 

        //update data in DB:
        var actionUrl = store.webAPIUrl + "PersonWeapons/" + personWeaponObj.personWeaponId; 

        personWeaponObj.isActive = true;
        delete personWeaponObj.weaponName; 

        $.ajax({
            method: "PUT",
            data: JSON.stringify(personWeaponObj),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            url: actionUrl,
            success: (result) => {

                var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                console.log(successMessage);

                this.$refs.personWeaponDatatable.LoadData(store.webAPIUrl + "personWeapons/personWeaponListDTO/" + this.personId, true);
                this.$refs.updateQualModal.HideModal();
            },
        });
      },
      DeleteWeapon(personWeaponObj){
        console.log("deleting weapon", personWeaponObj); 
        var actionUrl = store.webAPIUrl + "PersonWeapons/" + personWeaponObj.personWeaponId; 

        personWeaponObj.isActive = false;
        delete personWeaponObj.weaponName; 
        
        $.ajax({
            method: "PUT",
            data: JSON.stringify(personWeaponObj),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            url: actionUrl,
            success: (result) => {

                var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                console.log(successMessage);

                this.$refs.personWeaponDatatable.LoadData(store.webAPIUrl + "personWeapons/personWeaponListDTO/" + this.personId, true);
            },
        });
      }, 
      CreateEditFormSubmitted(){
        this.$refs.createNewPersonWeaponModal.HideModal();
        this.$refs.personWeaponDatatable.LoadData(store.webAPIUrl + "personWeapons/personWeaponListDTO/" + this.personId, true);
      }
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>
.personWeaponTableContainer{
  width: 85%;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  background:#ffe7de;
  border-radius:5px;
  min-height:200px;
}
    .weaponContainerHeader {
        background: #FF4500;
        /*background: #FF7F50;*/
        border-radius: 5px 5px 0px 0px;
        padding: 15px;
        color: white;
        font-size: 1.5rem;
    }
.tableContainer{
  padding:5px;
  margin:8px;
  background-color: rgba(255,255,255,.5);
}
.newBtnContainer{
  display:flex;
  padding-left:5px;
  gap:5px;
  align-self:start;
}
.bolder{
  font-weight: bolder;
}
.addWeaponIcon svg{
  fill:white;
}
</style>
